import type { FreightMatching } from "@x-mile/api-contract";
import type { DeepPartial } from "react-hook-form";
import type { CreateDeliveryProposalFormSchemaType } from "./model/validation";

// OfferCargoの構造とUIの構造が異なるため変換する必要がある
export const calculateDeliveryProposalInputValues = (
  draftOfferCargo: FreightMatching.schemas.OfferCargo,
): DeepPartial<CreateDeliveryProposalFormSchemaType> => {
  const firstDestination = draftOfferCargo.destinations[0];
  const loadingDestination = firstDestination
    ? {
        deadlineDate: draftOfferCargo.loadingOn,
        deadlineType: firstDestination.deadlineType ?? undefined,
        deadlineTime: firstDestination.deadlineTime ?? undefined,
        deadlineTimeEnd: firstDestination.deadlineTimeEnd ?? undefined,
      }
    : undefined;
  const transitDestinations = draftOfferCargo.destinations
    .slice(1, -1)
    .map((transitDestination) => {
      return {
        deadlineDate: undefined,
        deadlineType: transitDestination.deadlineType ?? undefined,
        deadlineTime: transitDestination.deadlineTime ?? undefined,
        deadlineTimeEnd: transitDestination.deadlineTimeEnd ?? undefined,
      };
    });
  const lastDestination =
    draftOfferCargo.destinations[draftOfferCargo.destinations.length - 1];
  const unloadingDestination = lastDestination
    ? {
        deadlineDate: draftOfferCargo.unloadingOn,
        deadlineType: lastDestination.deadlineType ?? undefined,
        deadlineTime: lastDestination.deadlineTime ?? undefined,
        deadlineTimeEnd: lastDestination.deadlineTimeEnd ?? undefined,
      }
    : undefined;
  return {
    loadingDestination,
    transitDestinations,
    unloadingDestination,
    shippingFee: draftOfferCargo.shippingFee ?? undefined,
    vehicleId: draftOfferCargo.vehicle?.id ?? undefined,
  };
};
